import React, { memo } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { getTestModeBannerInfo } from 'src/api/campaigns';
import { InfoIcon } from 'src/components/Icons/Info';
import { CampaignTestModeBannerType } from 'src/models/Campaigns/testModeBanner';
import { useOneRequest } from 'src/utils/hooks/useOneRequest';
import { useTHelper } from 'src/utils/i18n';
import { UiHoverTooltip } from 'src/components/UI/HoverTooltip';
import { commonSelector } from 'src/store/commonPart/selector';

type Props = {
  permanentUrl: string;
};

export const TestModeBanner: React.FC<Props> = memo(({ permanentUrl }) => {
  const tHelper = useTHelper('header.testModeBanner');

  const { response: model } = useOneRequest<CampaignTestModeBannerType>(getTestModeBannerInfo, {
    initialCall: true,
    data: { campaignPermanentUrl: permanentUrl },
    showErrors: false,
  });

  const { sidebarOpen } = useSelector(commonSelector);

  return model?.ShouldShowTestModeBanner ? (
    <div
      className={classNames('test-mode-campaign-wrapper header-banner', {
        sidebarOpen,
      })}
    >
      <div id="test-mode-campaign-banner" className="text-center">
        <p className="test-mode-draft-status-sub-title">{tHelper('draftStatusTitle')}</p>
        <p className="test-mode-campaign-text">
          {tHelper(model.IsDonationPage ? 'titleDP' : 'title', {
            campaignSingularTerminology: model.ExperienceTerminology.Singular,
          })}
        </p>

        <UiHoverTooltip
          text={tHelper('hint', {
            donationsLower: model.IsDonationPage
              ? model.DonationTerminology.Plural.toLowerCase()
              : model.ExperienceTerminology.Plural.toLowerCase(),
          })}
          place="bottom"
          className="test-mode-campaign-wrapper-icon-wrapper"
          tooltipClassName="tooltip-white-header test-mode-campaign-wrapper-tooltip"
          withPortal
        >
          <InfoIcon className="tooltip-info-icon" />
        </UiHoverTooltip>
      </div>
    </div>
  ) : null;
});
